export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7747f8398289240391fdf39a527f3cc34bdc29e3&name=fetchTypeahead!'